import * as React from 'react';
import { useHistory } from 'react-router';
import { Button } from '../components/Button';
import { PageHeader } from '../components/PageHeader';
import './ForbiddenPage.css';

/**
 * 利用者の権限が足りない画面を開いたときに、その画面の代わりに表示する。
 */
export const ForbiddenPage: React.FC = function () {
  const history = useHistory();

  return (
    <div className="ForbiddenPage">
      <PageHeader title="権限がありません" />
      <p className="ForbiddenPage-message">この画面を表示する権限がありません。</p>
      <div className="ForbiddenPage-actions">
        <Button onClick={() => history.push('/')}>トップへ戻る</Button>
      </div>
    </div>
  );
};
